const compact = (items) => items.filter(
  (part) => part !== null && typeof part !== "undefined" && `${part}`.trim().length > 0
);
export default function formatAddress(object, keys, separator = ", ") {
  const parts = keys.map((key) => {
    if (Array.isArray(key)) {
      return formatAddress(object, key, " ");
    }
    return object[key] || object[key.toLowerCase()];
  });
  return compact(parts).join(separator).trim();
}
